import Utils from "Engine/Utils";
import RelaxModel from "Base/model/RelaxModel";
import EntryPoint from "Engine/EntryPoint";

export default new class ParseRelax {

    constructor() {
        this.freeSpins = [];
    }

    parsGetToken(data) {
        RelaxModel.remoteusername = data.response.remoteusername;
        RelaxModel.replaytoken = data.response.replaytoken;
        RelaxModel.servertime = data.response.servertime;
        RelaxModel.token = data.response.token;
        RelaxModel.userid = data.response.userid;
    }

    parsRMLogin(data) {
        RelaxModel.country = data.country;
        RelaxModel.lastLogin = data.lastLogin;
        RelaxModel.savedSettings = data.savedSettings;
        RelaxModel.sid = data.sid;
        return this.parseDemoLoginResponse(data);
    }

    parseGetBalance(params) {
        const {b: balance} = params
        return {action: 'getBalance', params: {...params, balance}}
    }

    parsePing(params) {
        const {b: balance, realityCheck} = params
        RelaxModel.realityCheck = realityCheck;
        return {action: 'ping', params: {...params, balance}}
    }

    parseDemoLoginResponse(data) {
        //console.log(data);
        RelaxModel.sid = data.sid;
        RelaxModel.ended = data.refresh.ended || true;
        RelaxModel.realityCheck = data.stats ? data.stats.realityCheck : null;

        RelaxModel.refresh = data.refresh;

        if (data.refresh.restoreState && data.refresh.freespins) {
           RelaxModel.restoreState = JSON.parse(data.refresh.restoreState);
        }

        if (data.refresh.freespins) {
            this.freeSpins = data.refresh.freespins;
            EntryPoint.GameModel.baseSpin = data.refresh;
        }

        let spinData = data.refresh;
        let freeSpinsRestoreData = null;
        if (RelaxModel.restoreState && RelaxModel.restoreState.freeSpins && this.freeSpins) {
            freeSpinsRestoreData = RelaxModel.restoreState.freeSpins;
            this.freeSpins.splice(0, freeSpinsRestoreData.played);
            spinData = this.freeSpins[0];
        }
        spinData = spinData ? spinData : data.refresh;

        let newData = {
            action: 'init',
            session: data.sid,
            balance: data.stats.b,
            currency: data.stats.currency,
            freeBets: this._parseFreeBets(data.stats.freespins),
            params: {
                betPossible: data.limits.legalBets,
                linesPossible: [1],
            },
            current: {
                bet: data.refresh.ba || data.limits.defaultBet,
                lines: 1
            },
            spin: {
                reels: this._parseReels(spinData),
                winnings: this._parseWinnings(spinData)
            },
            freeSpins: freeSpinsRestoreData || this._parseFreeSpins(data.refresh),
            wilds: this._parseWilds(spinData)
        };
        return newData;
    }

    parseSpinResponse(data, freeSpins = false) {
        //console.log('parseSpinResponse', data.stats);
        RelaxModel.realityCheck = data.stats ? data.stats.realityCheck : null;

        if (data.freespins) {
            this.freeSpins = data.freespins;
            EntryPoint.GameModel.baseSpin = data;
        } else if(data.action !== "freeSpin") {
            RelaxModel.restoreState = null;
        }

        let newData = {
            action: 'spin',
            balance: data.stats ? data.stats.b : null,
            roundId: data.roundId,
            freeBets: freeSpins ? EntryPoint.GameModel.freeBets : this._parseFreeBets(data.stats.freespins),
            current: {
                bet: data.ba || null
            },
            spin: {
                reels: this._parseReels(data),
                winnings: this._parseWinnings(data)
            },
            freeSpins: this._parseFreeSpins(data),
            wilds: this._parseWilds(data)
        };
        return newData;
    }

    _parseReels(data) {
        let symbols = [];
        data.symbols.forEach((reel) => {
            symbols.push([]);
            reel.forEach((symbol) => {
                switch (symbol) {
                    case 'WR':
                        symbols[symbols.length - 1].push(2);
                        break;
                    case 'SC':
                        symbols[symbols.length - 1].push(1);
                        break;
                    default:
                        symbols[symbols.length - 1].push(+symbol.replace('S', '') + 2);
                        break;
                }
            });
        });
        return symbols;
    }

    _parseWinnings(data) {
        let winnings = null;
        if (data.winnings && data.winnings.length > 0) {
            winnings = {};
            winnings.totalWin = 0;
            data.winnings.forEach((winData) => {
                if (winData[4].search('S') !== -1) {
                    if (!winnings.lines) {
                        winnings.lines = [];
                    }
                    let lineData = {
                        symbol: +winData[4].replace('S', '') + 2,
                        count: winData[3].length,
                        line: winData[1],
                        path: this._parseWinPath(winData[3]),
                        win: winData[2],
                        multiplier: winData[5],
                    };
                    winnings.totalWin += winData[2];
                    winnings.lines.push(lineData);
                }
            });
            /*if (data.win) {
                winnings.totalWin = data.win
            }*/
        }

        let path = [];
        data.symbols.forEach((reel, rIndex)=>{
            reel.forEach((symbol, sIndex)=>{
                if (symbol === 'SC') {
                    path.push([rIndex, sIndex]);
                }
            });
        });
        if (path.length >= 3) {
            if (!winnings) {
                winnings = {};
            }
            winnings.scatters = [];
            winnings.scatters.push({
                symbol: 1,
                count: path.length,
                path: path,
                win: 0,
                multiplier: 1
            });
        }

        return winnings;
    }

    _parseWinPath(data) {
        let path = [];
        data.forEach((pathData) => {
            path.push([pathData.x - 1, pathData.y - 1]);
        });
        return path;
    }

    _parseFreeSpins(data) {
        /*let newData = {
            left: data.left,
            total: data.total
        };*/

        let spinWin = 0;
        if (data.winnings && data.winnings.length > 0) {
            spinWin = 0;
            data.winnings.forEach((winData) => {
                if (winData[4].search('S') !== -1) {
                    spinWin += winData[2];
                }
            });
        }

        let newData = {
            played: undefined,
            left: undefined,
            total: undefined,
            totalWin: undefined
        };

        if (data.freespins) {
            newData.played = 0;
            newData.left = data.freespins.length;
            newData.total = data.freespins.length;
            newData.totalWin = 0;
        } else {
            newData.left = data.spinsLeft;
            newData.played = data.spinsPlayed;
            newData.total = data.spinsLeft + data.spinsPlayed;
            newData.totalWin = data.runningTotal + spinWin;
        }

        if (newData.total === undefined || isNaN(newData.total)) {
            newData = null;
        }
        return newData;
    }

    _parseWilds(data) {
        return data.flyingWilds;
    }

    _parseFreeBets(data) {
        return data || null;
    }
}

//{"flyingWilds":[{"remainingStickyRounds":0,"multiplier":1,"featureType":"REGULAR_WILD","wildCoordinates":{"x":4,"y":1}}],"transform":[{"symbol":"WR","x":4,"y":1}],"stats":{"b":498675,"fm":100000,"currency":"EUR","tokens":0,"realityCheck":{"result":0,"sessionMinutes":19,"lossLimit":null,"winSum":0,"resetedResult":0,"hardErrors":false,"totalSessionMinutes":19,"sessionLimitSeconds":null,"betSum":0,"status":"ok"}},"grid":"reelSet1","freespins":[{"flyingWilds":[{"remainingStickyRounds":0,"multiplier":1,"featureType":"REGULAR_WILD","wildCoordinates":{"x":4,"y":4}}],"runningTotal":0,"transform":[{"symbol":"WR","x":4,"y":4}],"spinsPlayed":1,"spinsLeft":4,"grid":"reelSet2","stops":[62,53,40,46,49],"winnings":[["normal",0,120,[{"x":1,"y":2},{"x":2,"y":3},{"x":2,"y":4},{"x":3,"y":2},{"x":4,"y":4},{"x":5,"y":2},{"x":5,"y":3}],"S10",1,4]],"symbols":[["S4","S10","S5","S1"],["S9","S3","S10","S10"],["S6","S10","S1","S7"],["S3","S2","S7","WR"],["S3","S10","S10","S2"]]},{"flyingWilds":[{"remainingStickyRounds":0,"multiplier":1,"featureType":"REGULAR_WILD","wildCoordinates":{"x":4,"y":3}}],"runningTotal":120,"transform":[{"symbol":"WR","x":4,"y":3}],"spinsPlayed":2,"spinsLeft":3,"grid":"reelSet2","stops":[29,13,17,61,4],"winnings":[],"symbols":[["S6","S8","S1","S6"],["S9","S7","S7","S1"],["S8","S5","S3","S5"],["S9","S6","WR","S6"],["S10","S9","S7","S7"]]},{"flyingWilds":[{"remainingStickyRounds":0,"multiplier":1,"featureType":"REGULAR_WILD","wildCoordinates":{"x":4,"y":2}}],"runningTotal":120,"transform":[{"symbol":"WR","x":4,"y":2}],"spinsPlayed":3,"spinsLeft":2,"grid":"reelSet2","stops":[36,62,0,35,54],"winnings":[],"symbols":[["S8","S8","S5","S6"],["S5","S2","S4","S10"],["S10","S10","S10","S9"],["S9","WR","S8","S8"],["S3","S4","S3","S6"]]},{"flyingWilds":[{"remainingStickyRounds":0,"multiplier":1,"featureType":"REGULAR_WILD","wildCoordinates":{"x":4,"y":1}}],"runningTotal":120,"transform":[{"symbol":"WR","x":4,"y":1}],"spinsPlayed":4,"spinsLeft":1,"grid":"reelSet2","stops":[51,17,39,36,40],"winnings":[],"symbols":[["S7","S7","S6","S8"],["S4","S10","S10","S8"],["S6","S6","S10","S1"],["WR","S8","S8","S7"],["S5","S3","S5","S6"]]},{"flyingWilds":[],"runningTotal":120,"transform":[],"spinsPlayed":5,"spinsLeft":0,"grid":"reelSet2","stops":[46,10,19,32,29],"winnings":[],"symbols":[["S9","S8","S8","S9"],["S2","S5","S7","S9"],["S3","S5","S2","S10"],["S8","S6","S6","S9"],["S9","S9","S8","S4"]]}],"ended":true,"stops":[18,54,29,47,45],"roundType":"demo","winnings":[],"win":120,"symbols":[["S8","S10","S9"],["S1","S7","S5"],["S6","SC","S5"],["WR","S10","SC"],["S3","SC","S10"]],"ba":25}
